import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopAlertInformacja} from "../../../../../componentsTopsa/alerty/TopAlerts";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";

export default class DefinicjeTrasSelect extends Component{
    constructor(props) {
        super(props);
        this.state = {
            trasa: null
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.onClickAktualizuj=this.onClickAktualizuj.bind(this)
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0} wartosc={option.status} czyMarginesLewy={true}/></div>
    }

    onChangeSelect(e){
        this.setState({trasa:e})
        if(e !== null){
            this.props.handleSelectTrasa(e)
        }
    }

    onClickAktualizuj(){
        this.props.handleAktualizuj();
    }

    render() {

        return (
            <div>
                <Row>
                    <Col xs={12} sm={6} lg={3}>
                        <TopSelect onChange={this.onChangeSelect}
                                   value={this.state.trasa}
                                   options={this.props.trasy}
                                   valueKey={'idTr'}
                                   labelKey={'nazTr'}
                                   valueRenderer={this.formatTrasaSelect}
                                   optionRenderer={this.formatTrasaSelect}
                                   placeholder={'Wybierz trasę...'}
                        />
                    </Col>
                    <Col xs={12} sm={6} lg={9}>
                        <TopIf isTrue={this.props.czyPokazywacAktualizujBtn}>
                            <span  id={'AktualizujWykrzyknik'} style={(this.props.czyPokazacWykrzyknikAktualizuj)? {color:'firebrick'}:{color:'#ffffff'}}><i className={'fa fa-exclamation-triangle'}></i></span>
                        <TopButtonAction onClick={this.onClickAktualizuj}
                                         text={'Aktualizuj trasę'}
                                         iconType={'fa fa-clock-o'}
                                         btnSize={'medium'}
                                         elementId={'AktualizujButton'}
                        />
                            <div style={{display:'inline-block', marginLeft: '15px'}}>
                                <TopAlertInformacja text={'Po wprowadzonych zmianach należy zaktualizować trasę przyciskiem po lewej stronie.'}/>
                            </div>
                        </TopIf>
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/definicjeTras/components/DefinicjeTrasSelect.js